export default __webpack_public_path__ + "static/media/s4_xit-winter.849d26a6.png";